export const INVALID_PDF_UPLOAD_MESSAGE = "添付ファイルが不正なため登録できません";

export const isPdfUploadValidationError = (error) => {
  const detail = error?.response?.data?.detail;

  return (
    error?.response?.status === 400 &&
    typeof detail === "string" &&
    detail.includes("Invalid PDF upload")
  );
};
